export const capitalize = (str: string) =>
  str
    .split("")
    .map((el, idx) => (idx === 0 ? el.toUpperCase() : el.toLowerCase()))
    .join("");

